import Request from "../../model/Request";
import Response from "../../model/Response";
import {RestClient} from "../../util/RestClient";
import {Config} from "../../util/Config";
import PagedResponse from "../../entities/PagedResponse";
import Pagination from "../../entities/Pagination";
import ArticleCategory from "../../entities/productOrder/article/ArticleCategory";

export module ArticleCategoryService {
    export async function get(page: number = 1, pageSize: number = 15, filter?: string): Promise<Response<PagedResponse<ArticleCategory>>> {
        const url = Config.get("GET_ARTICLE_CATEGORY_URL", {page, pageSize, filter});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const articleCategoryData = response.data?.data;
            const paginationData = response.data?.pagination;
            if (articleCategoryData && paginationData) {
                const data = articleCategoryData.map((t: any) => new ArticleCategory(
                    t.id,
                    t.name,
                    t.description,
                    t.status
                ));
                const pagination = new Pagination(paginationData.currentPage, paginationData.pageSize, paginationData.elementsCount, paginationData.pageCount);
                return new Response<PagedResponse<ArticleCategory>>(true, {data, pagination}, response.error)
            }
        }
        return new Response<PagedResponse<ArticleCategory>>(false, undefined, response.error, response.status);
    }

    export async function getAll(): Promise<Response<ArticleCategory[]>> {
        const url = Config.get("GET_ARTICLE_CATEGORY_URL", {page: 1, pageSize: 1000, filter: ''});
        const request = new Request(url)
        const response = await RestClient.get(request)
        if (response.success) {
            const articleCategoryData = response.data?.data;
            if (articleCategoryData) {
                const data = articleCategoryData.map((t: any) => new ArticleCategory(
                    t.id,
                    t.name,
                    t.description,
                    t.status
                ));
                return new Response<ArticleCategory[]>(true, data, response.error)
            }
        }
        return new Response<ArticleCategory[]>(false, undefined, response.error, response.status);
    }

    export async function find(id: string): Promise<Response<ArticleCategory>> {
        const url = Config.get("FIND_ARTICLE_CATEGORY_URL", {id});
        const request = new Request(url)
        const response = await RestClient.get(request);
        if (response.success) {
            const articleCategoryData = response.data;
            if (articleCategoryData) {
                const articleCategory = new ArticleCategory(
                    articleCategoryData.id,
                    articleCategoryData.name,
                    articleCategoryData.description,
                    articleCategoryData.status
                );
                return new Response<ArticleCategory>(true, articleCategory, response.error);
            }
        }
        return new Response<ArticleCategory>(true, undefined, response.error, response.status);
    }

    export async function create(articleCategory: ArticleCategory): Promise<Response<any>> {
        const url = Config.get("CREATE_ARTICLE_CATEGORY_URL");
        const request = new Request(url, articleCategory);
        return await RestClient.post(request);
    }

    export async function update(articleCategory: ArticleCategory): Promise<Response<any>> {
        const url = Config.get("UPDATE_ARTICLE_CATEGORY_URL", {id: articleCategory.id});
        const request = new Request(url, articleCategory);
        return await RestClient.put(request);
    }

    export async function remove(articleCategory: ArticleCategory): Promise<Response<any>> {
        const url = Config.get("REMOVE_ARTICLE_CATEGORY_URL", {id: articleCategory.id});
        const request = new Request(url);
        return await RestClient.remove(request);
    }

}

